import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
// import CustomImg from "../Assets/img/custom-design.webp";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Je_welryspelling } from "../../../../Helpers/request";
import CustomDesignImg from "../Assets/img/custom_jewelry.jpg"
const CustomDesign = () => {
  return (
    <section className="custom-design section-space">
      <Container fluid className="showcase-container">
        <Row className="align-items-center mx-1440">

          <Col md={6} xs={12} className="text-center px-0">
            <div className="mx-auto mx-650">
              <Image src={CustomDesignImg} alt="Custom Design Jewellery" className="img-fluid" />
            </div>
          </Col>


          <Col md={6} xs={12} className="px-0">
            <Heading>
              {/* <span className="text-uppercase">Be the Designer</span> */}
              <h2 className="text-uppercase">Custom Design {Je_welryspelling}  </h2>
              <p>
                Create personalized {Je_welryspelling}   with our Custom Design
                service. Choose your materials and style for a unique
                piece crafted just for you.
              </p>
            </Heading>

            <div className="text-center">
              <Link to="/custom-design" className="btn outline-base-btn large ">
                Get Started
              </Link>
            </div>
          </Col>


        </Row>
      </Container>
    </section>
  );
};

export default CustomDesign;
